import {translations} from '../translations';
const initialState = {
  translations,
  selectedLanguage: 'en'
};

export default function(state = initialState, action){
    switch(action.type){
        case "SET_LANGUAGE":
            return {
              ...state,
              selectedLanguage: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/language.js